import * as React from 'react'
import { connect } from 'react-redux'
import Page from './../components/shared/page'
import VerificationData from './../components/verification/verificationData'
import { fetchUnverifiedVisits } from  './../redux/actions/verification'
import axios from 'axios'

class Verification extends React.Component {

  constructor() {
    super()

    this.state={
      totalVerifications: 0
    }
  }

  componentDidMount() {
    this.props.fetchUnverifiedVisits()
  }

  getVerificationTotal = () => {
    let headers = { "Content-Type": "application/json", "Authorization":`JWT ${this.props.auth.token}` }
    axios.get(`/api/verifications/verification_total/`, {headers}).then(results => {
      this.setState({totalVerifications: results.data})
    }).catch(error => {
      alert('Error')
    })
  }

  render () {
    return (
        <Page history={this.props.history}>
        <div className='recordings-header'>
          <p>Verification</p>
        </div>
        <div className='recordings-content'>
            <VerificationData unverifiedVisits={this.props.verification.unverifiedVisits} getVerificationTotal={this.getVerificationTotal} totalVerifications={this.state.totalVerifications}/>
        </div>
        <footer></footer>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUnverifiedVisits: () => {
      return dispatch(fetchUnverifiedVisits());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Verification)



// WEBPACK FOOTER //
// ./src/pages/verification.js